<template>
<div class="chapter">
<div class="inner_page">
<div id="List_of_Abbreviations">
<p class="fm-title"><a id="page_vii"><b>List of Abbreviations</b></a></p><a id="page_vii">
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="5%"/>
<col width="95%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para">ADC</p></td>
<td align="left" valign="top"><p class="table-para1">Aide-de-Camp</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">ANZAC</p></td>
<td align="left" valign="top"><p class="table-para1">Australian and New Zealand Army Corps</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">C-in-C</p></td>
<td align="left" valign="top"><p class="table-para1">Commander-in-Chief</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">CIGS</p></td>
<td align="left" valign="top"><p class="table-para1">Chief of the Imperial General Staff</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">GHQ</p></td>
<td align="left" valign="top"><p class="table-para1">General Headquarters</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">GOC</p></td>
<td align="left" valign="top"><p class="table-para1">General Officer Commanding</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">HE</p></td>
<td align="left" valign="top"><p class="table-para1">High Explosive</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">HQ</p></td>
<td align="left" valign="top"><p class="table-para1">Headquarters</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">KCB</p></td>
<td align="left" valign="top"><p class="table-para1">Knight Commander of the Bath</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">MEF</p></td>
<td align="left" valign="top"><p class="table-para1">Mediterranean Expeditionary Force</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">NATO</p></td>
<td align="left" valign="top"><p class="table-para1">North Atlantic Treaty Organization</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">NCO</p></td>
<td align="left" valign="top"><p class="table-para1">Non Commissioned Officer</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">OC</p></td>
<td align="left" valign="top"><p class="table-para1">Officer Commanding</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">RN</p></td>
<td align="left" valign="top"><p class="table-para1">Royal Navy</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">RND</p></td>
<td align="left" valign="top"><p class="table-para1">Royal Naval Division</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">RNVR</p></td>
<td align="left" valign="top"><p class="table-para1">Royal Navy Volunteer Reserve</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">T.F.</p></td>
<td align="left" valign="top"><p class="table-para1">Territorial Force</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">UK</p></td>
<td align="left" valign="top"><p class="table-para1">United Kingdom</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">VD</p></td>
<td align="left" valign="top"><p class="table-para1">Venereal Disease</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">WO</p></td>
<td align="left" valign="top"><p class="table-para1">War Office (UK)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para">2 i.c.</p></td>
<td align="left" valign="top"><p class="table-para1">Second in Command</p></td>
</tr>
</tbody>
</table>
</a></div><a id="page_vii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_List_of_Abbreviations.vue?1a65fce1